const phoneValidator = (value) => {
  const pattern = /^09[0-9]{8}$/
  return pattern.test(value) || '手機號碼格式不正確，請重新輸入'
}

export {
  phoneValidator
}
